/**
 * Created by anatoly on 05.05.2025
 */

const BackpackButton = cc.Node.extend({
    ctor: function () {
        this._super();

        this.backpack = Merge2.current.backpack;

        this.isButtonInactive = false;
        this.setAnchorPoint(0.5, 0.5);

        this.showed = true;

        this.createButton();

        this.backpack.on("addToStorage", this.onAddInStorage.bind(this), this);
        this.backpack.on("show", this.showUp.bind(this), this);

        cleverapps.focusManager.on("changeFocus", () => {
            if (this.highlightingNodes) {
                this.highlightingNodes.forEach((node) => node._setGlobalZOrder(cleverapps.focusManager.focus === "openBackpack"));
            }
        }, this);

        cleverapps.aims.registerTarget("backpack", this, {
            controls: ["backpackButton"]
        });
    },

    showUp: function () {
        if (this.showed) {
            return;
        }

        this.showed = true;

        this.button.setScale(0.3);
        this.button.runAction(
            new cc.ScaleTo(0.2, 1).easing(cc.easeBackOut())
        );
    },

    hide: function () {
        if (!this.showed) {
            return;
        }

        this.showed = false;

        this.button.runAction(
            new cc.ScaleTo(0.2, 0.3).easing(cc.easeBackIn())
        ).setFinalize(() => this.button.setScale(0));
    },

    disable: function () {
        this.isButtonInactive = true;
    },

    enable: function () {
        this.isButtonInactive = false;
    },

    createButton: function () {
        const button = this.button = new cleverapps.Spine(bundles.merge.jsons.backpack_icon);
        button.setAnimation(0, "idle", true);

        cleverapps.UI.applyHover(button);
        cleverapps.UI.onClick(button, () => {
            if (!this.isButtonInactive) {
                this.onClicked();
            }
        });

        this.setContentSize(button.getContentSize());
        button.setPosition(this.width / 2, this.height / 2);

        this.addChild(button);
    },

    onClicked: function () {
        cleverapps.focusManager.display({
            stack: true,
            focus: "openBackpack",
            action: function (f) {
                new BackpackWindow();

                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    onAddInStorage: function () {
        this.button.setAnimationAndIdleAfter("animation", "idle");
    },

    startHintPulse: function (options) {
        options = options || {};

        this.stopHintPulse();

        const baseScale = this.hintPulseBaseScale = this.getScale();
        this.hintPulseAction = this.runAction(new cc.Sequence(
            new cc.DelayTime(options.delay || 0),
            new cc.CallFunc(() => {
                this.hintPulseAction = this.runAction(new cc.RepeatForever(new cc.Sequence(
                    new cc.ScaleTo(0.5, baseScale * 1.1).easing(cc.easeInOut(2)),
                    new cc.DelayTime(0.1),
                    new cc.ScaleTo(0.6, baseScale).easing(cc.easeInOut(2))
                )));
            })
        ));
    },

    stopHintPulse: function () {
        if (this.hintPulseAction) {
            this.stopAction(this.hintPulseAction);
            this.setScale(this.hintPulseBaseScale);
        }
        delete this.hintPulseAction;
    },

    playDragAnimation: function (playing) {
        if (playing) {
            this.button.setCompleteListener();
            if (this.button.getCurrentAnimationName(0) !== "animation") {
                this.button.setAnimation(0, "animation", true);
            }
        } else {
            this.button.setCompleteListenerOnce(() => {
                this.button.setAnimation(0, "idle", true);
            });
        }
    },

    checkDropInside: function (unitView) {
        if (cleverapps.tutorial.isActive() && !cleverapps.tutorial.checkConditions({ backpack: true })) {
            return false;
        }

        const inside = this.showed && cc.rectContainsPoint(
            cc.rect(0, 0, this.width, this.height),
            this.convertToNodeSpace(unitView.parent.convertToWorldSpace(unitView.getPosition()))
        );

        if (!this.dragAnimationLocked) {
            this.playDragAnimation(inside);
        }

        return inside;
    },

    handleDropEnd: function (unitView) {
        this.playDragAnimation(false);

        if (cleverapps.tutorial.isActive() && !cleverapps.tutorial.checkConditions({ backpack: true })) {
            return false;
        }

        if (this.backpack.isFull()) {
            Merge2.current.showHint(this, Messages.get("BackPack.nofreeslot"));
            return false;
        }

        if (!this.backpack.canAcceptUnit(unitView.unit)) {
            Merge2.current.showHint(this, Messages.get("Backpack.CannotStore"));
            return false;
        }

        return this.backpack.handleDropEnd(unitView.unit);
    }
});

Field.DROP_TARGETS.push(() => cleverapps.aims.getTarget("backpack"));